<!-- <ngx-spinner type="ball-atom"></ngx-spinner> -->
<mat-form-field appearance="fill" [class.mat-form-field-disabled]="disabled" [ngClass]="isFullWidth ? 'full-width' : ''">
  <mat-label>{{ label }}</mat-label>

  <input
    matInput
    [formControl]="searchControl"
    [placeholder]="placeholder"
    [matAutocomplete]="auto"
    [disabled]="disabled"
    autocomplete="off">

  <mat-autocomplete #auto="matAutocomplete"
    [class]="panelClass"
    (optionSelected)="onOptionSelected($event.option.value)"
    (opened)="isPanelOpen = true"
    (closed)="isPanelOpen = false">
    <mat-option *ngFor="let option of filteredOptions" [value]="option">
      {{ getDisplayText(option) }}
    </mat-option>

    <mat-option *ngIf="hasMoreResults" [value]="null" disabled class="more-results-indicator">
      ... and {{ totalFilteredCount - maxResults }} more results (please refine your search)
    </mat-option>

    <mat-option *ngIf="filteredOptions.length === 0 && searchControl.value && searchControl.value.length >= 3" [value]="null" disabled>
      No results found
    </mat-option>
  </mat-autocomplete>
</mat-form-field>
